<template>
  <el-select-tree
    @change="selectOne"
    :data="bankLevelList"
    :props="treeProps"
    v-model="levelId"
    :disabled="disabled"
    :default-expand-all="true"
    :check-strictly="true"
    placeholder="默认"/>
</template>

<script>
import {treeDataTranslate} from '@/utils'

export default {
  name: 'bankLevelSelect',
  data() {
    return {
      levelId: this.bankLevelId,
      treeProps: {
        value: 'id',
        children: 'children',
        label: 'levelName'
      },
      bankLevelList: [],
    }
  },
  props: {
    bankType: [String],
    bankLevelId: [String],
    disabled: Boolean
  },
  watch: {
    bankType: function (newVal) {
      this.levelId = '';
      if (newVal !== "") {
        this.getBankLevelList();
      } else {
        this.bankLevelList = [];
      }
    },
    bankLevelId: function () {
      this.levelId = this.bankLevelId;
    }
  },
  methods: {
    selectOne(event) {
      this.$emit('update:bankLevelId', event);
    },
    getBankLevelList() {
      this.$http({
        url: this.$http.adornUrl('/sys/bankLevel/list'),
        method: 'post',
        data: this.$http.adornData({bankType: this.bankType,pageIndex:-1,pageSize:-1}),
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.bankLevelList = treeDataTranslate(data.data.list)
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bank/bank-level-select.vue